import { c as _c } from "react-compiler-runtime";
import { useVirtualizedCellAnchor } from '../../table/hooks/useVirtualizedCellAnchor';
export const useFillHandleAnchorElement = t0 => {
  var _coord$rowIndex, _coord$columnIndex;
  const $ = _c(5);
  const {
    coord,
    scrollContainerElementRef,
    widths
  } = t0;
  const t1 = (_coord$rowIndex = coord === null || coord === void 0 ? void 0 : coord.rowIndex) !== null && _coord$rowIndex !== void 0 ? _coord$rowIndex : null;
  const t2 = (_coord$columnIndex = coord === null || coord === void 0 ? void 0 : coord.columnIndex) !== null && _coord$columnIndex !== void 0 ? _coord$columnIndex : null;
  let t3;
  if ($[0] !== scrollContainerElementRef || $[1] !== t1 || $[2] !== t2 || $[3] !== widths) {
    t3 = {
      rowIndex: t1,
      columnIndex: t2,
      scrollContainerElementRef,
      widths,
      maxWaitMs: 2000
    };
    $[0] = scrollContainerElementRef;
    $[1] = t1;
    $[2] = t2;
    $[3] = widths;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return useVirtualizedCellAnchor(t3);
};